import pushGTMEvent from './push-gtm-event';

export interface PrismicExperimentImpressionGTMEvent {
    /** Name of the experiment / test (e.g. `homepage_hero_ab_test`). */
    experimentName: string;
    /** Human-readable variation name (e.g. `variant_b`). */
    variationName: string;
    /** Stable variation identifier where available (e.g. a Prismic document id). */
    variationId?: string;
    /** Optional component/slice name the experiment is rendered within. */
    componentName?: string;
    /** Optional locale the experiment is running in (e.g. `en-AU`). */
    locale?: string;
}

/**
 * Push a `prismic_experiment_impression` event to the dataLayer when a Prismic
 * A/B variation is shown to the rider. Use this for any Prismic-driven
 * component test so experiment analytics live in the site's own dataLayer
 * rather than a vendor iframe.
 */
export default function prismicExperimentImpressionGTMEvent({
    experimentName,
    variationName,
    variationId,
    componentName,
    locale,
}: PrismicExperimentImpressionGTMEvent): void {
    pushGTMEvent('prismic_experiment_impression', {
        experiment: {
            provider: 'prismic',
            experiment_name: experimentName,
            component_name: componentName,
            variation_name: variationName,
            variation_id: variationId,
            locale,
        },
    });
}
